import React from 'react';
import T from 'prop-types';
import { Spinner } from '..';

export const Count = ({ className, countNo, onClick, isLoading }) => {
    return <div className={className} onClick={onClick}><span>
        {countNo}
        <Spinner color={'black'} loading={isLoading} size={40} />
    </span></div>;
};

Count.T = {
    countNo: T.string,
    className: T.string,
    onClick: T.func
};

Count.defaultProps = {
    className: 'countDefaultCls',
    onClick: null,
};
